import React from 'react'
import { Button, Card, Table, Tag } from 'antd'
import { useNavigate } from 'react-router-dom'
import UseMentorAssignment from 'PlatForms/OrgLMS/Hooks/AdminHooks/useMentorAssignment'

const MentorGroupDetail = () => {
  const { loadingGroups, groupData, loading } = UseMentorAssignment()
  const navigate = useNavigate()

  const columns = [
    {
      title: 'Group Name',
      dataIndex: 'groupName',
      key: 'groupName',
    },
    {
      title: 'Mentor Name',
      dataIndex: 'mentorName',
      key: 'mentorName',
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (text) => new Date(text).toLocaleString(),
    },
    {
      title: 'Members Count',
      dataIndex: 'membersCount',
      key: 'membersCount',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => {
        let color = status === 0 ? 'blue' : status === 1 ? 'green' : 'default'
        let text = status === 0 ? 'In Progress' : status === 1 ? 'Complete' : 'Unknown'

        return <Tag color={color}>{text}</Tag>
      },
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Button type="link" onClick={() => navigate(`/group-detail/${record.groupId}`)}>
          View Detail
        </Button>
      ),
    },
  ]

  return (
    <Card
      title="Created Group List"
      className="card-professional"
      loading={loading}
      extra={
        <Button type="default" onClick={() => navigate('/internship')}>
          Back
        </Button>
      }
    >
      <>
        <Table loading={loadingGroups} columns={columns} dataSource={groupData} rowKey="groupId" />
      </>
    </Card>
  )
}

export default MentorGroupDetail
